import { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../authContext';
import { performLogout } from '../../utils/logout';
import './UserWrapper.css';

function UserWrapper() {
  const { email, level, isManager } = useContext(AuthContext);
  const [showLogout, setShowLogout] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { t: tCommon } = useTranslation('common');

  // Determina se está na página de administração ou na home-page
  const isManagementPage = location.pathname === '/management';
  const isHomePage = location.pathname === '/hub';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        const userIcon = document.querySelector('.header__user-initial');
        if (userIcon && !userIcon.contains(event.target)) {
          setShowLogout(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="involucro-user">
      <button
        data-testid = "user-initial"
        className="header__user-initial"
        onClick={() => setShowLogout(!showLogout)}
      >
        {email?.charAt(0)?.toUpperCase()}
      </button>
      {showLogout && (
        
        <div className="user-menu" data-testid="user-menu" ref={menuRef}>
          {/* "Minha Conta" só aparece na área de administrador (management) */}
          {isManagementPage && (
            <button
              className="user-menu-item"
              onClick={() => {
                localStorage.clear();
                setShowLogout(false)
                navigate('/hub');
              }}
            >
              {tCommon('minha conta')}
            </button>
          )}
          
          {/* "Área do moderador" só aparece na home-page (hub) */}
          {isHomePage && (level === 'dev' || level === 'mod') && (
            <button
              className="user-menu-item"
              data-testid="management"
              onClick={() => {
                setShowLogout(false)
                navigate('/management')}}
            >
              {tCommon('moderador')}
            </button>
          )}
          {/* Gestão de Grupos: só no menu do avatar quando NÃO tem acesso ao
              painel de moderador — quem também é moderador vê a opção lá
              dentro (button-group), não aqui (FR-001/FR-002). */}
          {isHomePage && isManager && !(level === 'dev' || level === 'mod') && (
            <button
              className="user-menu-item"
              data-testid="group-management"
              onClick={() => {
                setShowLogout(false)
                navigate('/group-management')}}
            >
              {tCommon('groupManagement')}
            </button>
          )}
          <button
            className="user-menu-item"
            data-testid="logout"
            onClick={() => performLogout(navigate)}
          >
            {tCommon('sair')}
          </button>
        </div>
      )}
    </div>
  );
}

export default UserWrapper;